import { useState } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import classnames from 'classnames';
import Button from '@App/components/ui/Button';
import LevelTwoTagFilter from './LevelTwoTagFilter';
import LabelsFilter from './LabelsFilter';

export default function Filters({ tags, loading }) {
    const [tab, setTab] = useState(null);

    const onTab = (event) => {
        const id = event.currentTarget.value;
        setTab(prevTab => prevTab === id ? null : id);
    };

    const renderContent = () => {
        switch (tab) {
            case 'labels':
                return <LabelsFilter className="filters__column filters__column--large" />;

            default:
                return <LevelTwoTagFilter id={tab} className="filters__column filters__column--large" />;
        }
    };

    if (loading) {
        return <ul key="level-1" className="filters__column loading" />;
    }

    return (
        <>
            <ul className="filters__column">
                {tags.map(({ id, name }) => (
                    <li key={`${id}-item`} className={classnames('filters__item', { active: tab === id })}>
                        <Button key={`${id}-button`} label={name} onClick={onTab} value={id} className="" />
                    </li>
                ))}
                <li key="labels" className={classnames('filters__item', { active: tab === 'labels' })}>
                    <Button label={I18n.t('search.labels.label')} value="labels" onClick={onTab} className="" />
                </li>
            </ul>
            {tab ? renderContent() : null}
        </>
    );
}

Filters.propTypes = {
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired
    ),
    loading: PropTypes.bool.isRequired,
};
